import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { ProductInputWithQuantity } from "./AddProductListModal";

export const AddProductListFormEffects: React.FC<{
    pickedCategoryId: number | null;
    unitForSale: number | null;
    setSelectedMainUnitId: (id: number | null) => void;
}> = ({ pickedCategoryId, unitForSale, setSelectedMainUnitId }) => {
    const { setFieldValue } = useFormikContext<ProductInputWithQuantity>();

    useEffect(() => {
        if (pickedCategoryId) {
            setFieldValue("category", pickedCategoryId, false);
        }
    }, [pickedCategoryId, setFieldValue]);

    useEffect(() => {
        setSelectedMainUnitId(unitForSale ?? null);
    }, [unitForSale, setSelectedMainUnitId]);

    return null;
};
